import type { NoteFilter } from '../api/notes-cache';

/** Chemins de l'application, centralisés pour éviter les chaînes en dur. */
export const paths = {
  notes: '/',
  reminders: '/reminders',
  archive: '/archive',
  trash: '/trash',
  label: (id: string) => `/label/${id}`,
  search: '/search',
  login: '/login',
  register: '/register',
} as const;

/** Déduit le filtre de notes de l'URL courante. */
export function filterFromLocation(pathname: string, search: URLSearchParams): NoteFilter {
  if (pathname.startsWith('/reminders')) return { view: 'reminders' };
  if (pathname.startsWith('/archive')) return { view: 'archive' };
  if (pathname.startsWith('/trash')) return { view: 'trash' };
  const label = pathname.match(/^\/label\/([^/]+)/);
  // Dans un libellé, Keep affiche aussi les notes archivées.
  if (label) return { view: 'all', labelId: decodeURIComponent(label[1]!) };
  if (pathname.startsWith('/search')) {
    const filter: NoteFilter = { view: 'all' };
    const q = search.get('q')?.trim();
    const color = search.get('color');
    const type = search.get('type');
    if (q) filter.q = q;
    if (color) filter.color = color as NoteFilter['color'];
    if (type) filter.type = type as NoteFilter['type'];
    if (search.get('images') === 'true') filter.hasImages = true;
    return filter;
  }
  return { view: 'notes' };
}
